<template>
  <div>
    <phoneNav />
    <div class="officeDetailPhone">
      <div class="project-intro">
        <swiperBannerPhone />
        <div class="project-cont">
          <h2>青春里公寓 3</h2>
          <h4>致力上海租房和创业的梦想青年提供高品质的公寓</h4>
          <div class="dec">
            <span
              >青春里公寓位于上海张江科学城核心区，公寓旗下现有张江金科路与居里路两大青年社区。社区含2000余套公寓，及篮球场、足球场、健身房、青春小街等公共空间，打造“生活+创业+社交”理想化社区，满足青年安居乐业、实现自我的梦想，体验沟通、交友、互动的租居理念，感受创新、个性、自由的文化氛围。
            </span>
          </div>
        </div>
        <div class="project-intro-cont">
          <h3>概况</h3>
          <div class="intro-cont-box">
            <Row class="cont-part1">
              <Col span="12">
                <div class="img-l">
                  <img src="../../assets/images/web/ico-fpic1.png" />
                </div>
                <div class="txt-r">
                  <div>45-125㎡</div>
                  <p>出租面积</p>
                </div>
              </Col>
              <Col span="12">
                <div class="img-l">
                  <img src="../../assets/images/web/ico-fpic2.png" />
                </div>
                <div class="txt-r">
                  <div>一房至三房</div>
                  <p>户型</p>
                </div>
              </Col>
              <Col span="12">
                <div class="img-l">
                  <img src="../../assets/images/web/ico-fpic3.png" />
                </div>
                <div class="txt-r">
                  <div>拎包入住</div>
                  <p>方式</p>
                </div>
              </Col>
              <Col span="12">
                <div class="img-l">
                  <img src="../../assets/images/web/ico-fpic3.png" />
                </div>
                <div class="txt-r">
                  <div>高品质精装</div>
                  <p>装修</p>
                </div>
              </Col>
            </Row>
          </div>
          <h3>基本信息</h3>
          <div class="intro-cont-box">
            <Row class="tit-dec">
              <Col span="12"> <span>楼栋：</span>5 </Col>
              <Col span="12"> <span>楼层：</span>201 </Col>
              <Col span="12"> <span>房号：</span>1103 </Col>
              <Col span="12"> <span>交付标准：</span>空调 </Col>
              <Col span="12"> <span>项目：</span>看省 </Col>
              <Col span="12"> <span>付款方式：</span>现金 </Col>
              <Col span="12"> <span>最短租期：</span>3个月 </Col>
              <Col span="12"> <span>起租期：</span>现房 </Col>
            </Row>
          </div>
          <h3>公寓服务</h3>
          <div class="intro-cont-box">
            <ul class="apartmentServe">
              <li>专职管家服务</li>
              <li>24小时保安</li>
              <li>维修保洁</li>
              <li>知名物业</li>
              <li>社交活动</li>
              <li>企业活动</li>
              <li>创客空间</li>
            </ul>
          </div>
          <h3>出租房型</h3>
          <div class="intro-cont-box">
            <Row type="flex" justify="space-between" class="code-row-bg">
              <Col span="12">
                <div class="equ">
                  <img src="../../assets/images/web/houseType1.jpg" />
                  <p>一居室</p>
                </div>
              </Col>
              <Col span="12">
                <div class="equ">
                  <img src="../../assets/images/web/houseType2.jpg" />
                  <p>二居室</p>
                </div>
              </Col>
              <Col span="12">
                <div class="equ">
                  <img src="../../assets/images/web/houseType3.jpg" />
                  <p>三居室</p>
                </div>
              </Col>

              <Col span="12"> &nbsp; </Col>
            </Row>
          </div>
          <h3>服务设施</h3>
          <div class="intro-cont-box">
            <Row type="flex" justify="space-between" class="code-row-bg">
              <Col span="12">
                <div class="equ">
                  <img src="../../assets/images/web/equip-pic2.png" />
                  <p>健身房</p>
                </div>
              </Col>
              <Col span="12">
                <div class="equ">
                  <img src="../../assets/images/web/equip-pic3.png" />
                  <p>体育馆</p>
                </div>
              </Col>
              <Col span="12">
                <div class="equ">
                  <img src="../../assets/images/web/equip-pic4.png" />
                  <p>酒吧</p>
                </div>
              </Col>
              <Col span="12">
                <div class="equ">
                  <img src="../../assets/images/web/equip-pic5.png" />
                  <p>餐厅</p>
                </div>
              </Col>
            </Row>
          </div>
          <h3>位置信息</h3>
          <div class="intro-cont-box">
            <Row class="office-addr">
              <Col span="24">
                <!-- <div class="office-map">
                 <img src="../../assets/images/web/office-map.jpg" />
                </div> -->
                 <!-- <MapContainer ref="mapContainer" height="400px" @loaded="hanldeMapLoaded">
                                            </MapContainer> -->
              </Col>
              <Col span="24">
                <div class="addr-msg">
                  <ul>
                    <li>
                      <div class="iconL">
                        <Icon type="md-pin" />
                      </div>
                      <div class="msgR">
                        <p>地址</p>
                        <div>上海市浦东新区盛荣路188弄</div>
                      </div>
                    </li>
                    <li>
                      <div class="iconL">
                        <Icon type="md-bus" />
                      </div>
                      <div class="msgR">
                        <p>班车</p>
                        <div>园区班车往返至2号线金科路站</div>
                      </div>
                    </li>
                    <li>
                      <div class="iconL">
                        <Icon type="md-subway" />
                      </div>
                      <div class="msgR">
                        <p>地铁</p>
                        <div>地铁13号线中科路站</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <div class="project-introBt">
          <ProjectCont :tit="projectTit" :msg="projectDec" :subheading="subHeading" />
          <div class="appoint-box">
            <Affix :offset-top="70">
              <AppointmentPhone :msg="appointMsg" :recordType="0" :tit="appointTit" :btnTxt="appointBtnTxt"/>
            </Affix>
          </div>
        </div>
      </div>
    </div>
    <FooterPhone />
  </div>
</template>

<script>
import ProjectCont from "@/components/ProjectCont.vue";
// import AppointmentR from '@/components/AppointmentR.vue';
import swiperBannerPhone from "../../components/swiperBannerPhone";
import phoneNav from "../../components/phoneNav";
import FooterPhone from "../../components/FooterPhone";
import AppointmentPhone from "../../components/AppointmentPhone";
//import MapContainer from '@/components/MapContainer.vue';

export default {
  name: "RentApartmentView",
  components: {
    ProjectCont,
    // AppointmentR,
    swiperBannerPhone,
    phoneNav,
    FooterPhone,
    AppointmentPhone,
    //MapContainer
  },
  data() {
    return {
      projectTit: "青春里公寓",
      subHeading: "致力于为上海租房和创业的梦想青年提供高品 质的公寓",
      projectDec:
        "      青春里公寓位于上海张江科学城核心区，公寓旗下现有张江金科路与居里路两大青年社区。 \n       社区含2000余套公寓，及篮球场、足球场、健身房、青春小街等公共空间，打造“生活+创业+社交”理想化社区，满足青年安居乐业、实现自我的梦想，体验沟通、交友、互动的租居理念，感受创新、个性、自由的文化氛围。",

      appointTit: "预约参观",
      appointMsg: "填写您的信息，及时获取青春里公寓详情。",
      appointBtnTxt:"提交预约",
      roomId: 1801,
      room: {},
      projectId: 100135,
      project: {},
      contentList: [],
      // imageList:[],
    };
  },
  methods: {
    hanldeMapLoaded({ map, AMap }) {
      console.log(map);
      this.AMap = AMap;
      var center = new AMap.LngLat("121.60568", "31.172576", true);
      let marker = new AMap.Marker({
          position: center,
          offset: [0, -10]
      });
      map.add(marker);
      map.setZoomAndCenter(14, center, true, 400);
    },
  },
  mounted() {
  },
};
</script>

<style lang="less">
.rootApp .ivu-layout {
  box-shadow: none;
}

.officeDetailPhone {
  background-color: #fff;
  height: 100vh;
  overflow-y: scroll;
  .project-intro {
    padding: 60px 20px;
    box-sizing: border-box;
    .project-cont {
      h2 {
        font-size: 24px;
        padding-top: 20px;
      }
      h4 {
        font-size: 14px;
        margin-bottom: 10px;
        font-weight: normal;
      }
      .dec {
        font-size: 12px;
        color: #565d69;
        margin-bottom: 30px;
      }
    }
    .project-intro-cont {
      h3 {
        font-size: 14px;
        margin-bottom: 10px;
      }

      .intro-cont-box {
        margin-bottom: 30px;

        .apartmentServe {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: -20px;

          li:before {
            content: "";
            width: 6px;
            height: 6px;
            display: inline-block;
            border-radius: 50%;
            background: #3377e7;
            vertical-align: middle;
            margin-right: 10px;
          }

          li {
            width: 33%;
            margin-bottom: 20px;
            list-style: none;
          }
        }

        .cont-part1 {
          display: flex;
          justify-content: flex-start;

          .ivu-col-span-12 {
            font-size: 12px;
            display: flex;
            flex-flow: row;
            align-items: center;
            margin-bottom: 10px;

            .img-l {
              margin-right: 15px;
              width: 30px;
              img {
                display: block;
                width: 100%;
                height: auto;
              }
            }

            .txt-r {
              font-size: 14px;

              p {
                font-size: 12px;
                color: #999;
              }
            }
          }
        }

        .tit-dec {
          margin-bottom: -10px;
          font-size: 12px;

          .ivu-col-span-12 {
            margin-bottom: 10px;

            span {
              width: 70px;
              color: #666;
            }
          }
        }

        .code-row-bg {
          text-align: center;
          margin: 0 -10px;

          .ivu-col-span-12 {
            margin-bottom: 20px;

            .equ {
              margin: 0 10px;
              background-color: #fff;
              border: 1px solid #efefef;
              border-radius: 5px;

              img {
                width: 100%;
                height: 95px;
                border-radius: 5px;
                line-height: 0;
                display: block;
              }

              p {
                font-size: 14px;
                line-height: 32px;
              }
            }

            .equ:hover {
              box-shadow: 0px 0px 2px 0px rgba(70, 139, 254, 0.7);
            }
          }
        }

        .office-addr {
          .office-map {
            border: 1px solid rgba(0, 0, 0, 0.3);

            img {
              width: 100%;
              height: 100%;
              line-height: 0;
              display: block;
            }
          }

          .addr-msg {
            margin-top: 20px;

            ul {
              li {
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                .iconL {
                  background-color: #66cff2;
                  height: 30px;
                  line-height: 30px;
                  width: 30px;
                  text-align: center;
                  color: #fff;
                  font-size: 18px;
                  border-radius: 5px;
                  flex: none;
                }

                .msgR {
                  margin-left: 10px;
                  font-size: 14px;

                  p {
                    color: #3376fe;
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
